import styled from 'styled-components'
import { displayStatus } from '../../utils'

export default styled.div`
  position: absolute;
  top: 0.75rem;
  left: 1.75rem;
  padding: 0.25rem 0.75rem;
  color: #fff;
  font-size: 0.8rem;
  background-color: ${(props) => {
    if (displayStatus(props.status) === 'Under Contract') {
      return 'rgb(150, 150, 150)'
    }
    return props.theme.primary
  }};
  opacity: 0.9;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/StatusTag/index.js